<template>
  <b-modal
    id="service-feedback"
    :title="$t('feedback.title')"
    :cancel-title="$t('feedback.cancel')"
    @hidden="resetFeedback"
  >
    <p>{{ $t("feedback.description") }}</p>

    <b-form-textarea
      v-model="feedbackText"
      rows="6"
      class="mt-3"
      :placeholder="$t('feedback.placeholder')"
    />

    <template #modal-footer>
      <b-btn variant="secondary" @click="$bvModal.hide('service-feedback')">
        {{ $t("cancel-btn") }}
      </b-btn>

      <b-btn
        variant="primary"
        :disabled="isSending || feedbackText.trim() === ''"
        @click="sendFeedback"
      >
        <b-spinner small v-if="isSending" class="mr-1"></b-spinner>
        {{ $t("feedback.send") }}
      </b-btn>
    </template>
  </b-modal>
</template>

<script>
import ClientService from "../../../services/client";

export default {
  props: {
    projectFileName: { type: String, default: "Projet de service" }
  },
  data() {
    return {
      feedbackText: "",
      isSending: false,
      clientData: { firstName: "", lastName: "", pkClient: "" }
    };
  },
  methods: {
    open() {
      this.$bvModal.show("service-feedback");
    },

    resetFeedback() {
      this.feedbackText = "";
      this.isSending = false;
    },

    async sendFeedback() {
      if (!this.feedbackText.trim()) return;

      this.isSending = true;

      try {
        // Récupérer les infos du client connecté
        const clientResponse = await ClientService.get();
        this.clientData = clientResponse.data;

        // Préparer le DTO à envoyer au backend
        const feedbackData = {
          clientPk: this.clientData.pkClient,
          projectFileName: this.projectFileName,
          feedbackText: this.feedbackText.trim(),
          clientFirstName: this.clientData.firstName,
          clientLastName: this.clientData.lastName
        };

        // Envoi via ClientService (passera par le middleware)
        const response = await ClientService.sendFeedback(feedbackData);

        if (!response.success) {
          throw new Error("Feedback non envoyé");
        }
        //  Tracking GA4 : feedback envoyé
        if (this.$gtag) {
          this.$gtag.event("projet_service_feedback_send", {
            file_name: this.projectFileName,
            client: `${this.clientData.firstName} ${this.clientData.lastName}`,
            date: new Date().toISOString()
          });
        }

        this.$bvModal.hide("service-feedback");
        this.$bvToast.toast(this.$t("feedback.success"), {
          variant: "success",
          autoHideDelay: 4000
        });
      } catch (error) {
        this.$bvToast.toast(this.$t("feedback.error"), {
          variant: "danger",
          autoHideDelay: 5000
        });
      } finally {
        this.isSending = false;
      }
    }
  }
};
</script>
